module.exports = __webpack_public_path__ + "img/logo.7619cee7.png";